import { render } from "./InnerHeader.vue?vue&type=template&id=4c6fdb97"
import script from "./InnerHeader.vue?vue&type=script&lang=js"
export * from "./InnerHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__